/**
 * Name: Reveal
 */

import Component from "@lunaweb/vega-reactor-js/src/patterns/Component";

export default class Reveal extends Component {
  static settings = {};

  #label;
  #timeout;

  #handleClick;
  #handleKeyUp;

  constructor (element, options = {}) {
    super(element, {
      ...Reveal.settings,
      ...options
    });

    this.#label = this.element.querySelector('[data-reveal-label]');

    this.#handleClick = this._handleClick.bind(this);
    this.#handleKeyUp = this._handleKeyUp.bind(this);
  }

  _handleClick (e) {
    e.preventDefault();
    this.reveal();
  }

  _handleKeyUp (e) {
    if (e.key == " " || e.code == "Space" || e.keyCode == 32) {
      this.reveal();
    }
  }

  reveal () {
    this.element.removeEventListener('click', this.#handleClick);
    this.element.removeEventListener('keyup', this.#handleKeyUp);
    if (this.element.href) {
      this.element.removeAttribute('role');
    }
    this.#label.textContent = this.element.dataset.reveal;

    this.element.blur();

    this.#timeout = setTimeout((e) => {
      this.element.focus();
      this.#timeout = null;
    }, 1);
  }

  mount () {
    this.element.addEventListener('click', this.#handleClick);
    this.element.addEventListener('keyup', this.#handleKeyUp);

    super.mount();
  }

  unmount () {
    this.element.removeEventListener('click', this.#handleClick);

    super.unmount();
  }
}
